// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"2a454989","146":"55b7ada2","234":"82695e30","470":"96f62946","787":"2f563901","845":"ebba32ae","954":"36c07f5a"}[chunkId] + ".chunk.js";
};